import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { Modal } from 'react-bootstrap';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { loginAction } from '../../Actions';
import {routeName} from '../../../src/Service/env';
import {audioFunc} from "../../Service/helper";

const styles= theme =>({
    textField: {
        marginTop: 0,
        fontSize: '1.6em',
        marginBottom: 0,
        width: 135,
    },
    grid:{
        width: '100%'
    },
    button: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%'
    },
    cancelButton: {
        fontSize:'medium',
        marginBottom:'3%'
    }
});

class AppLogin extends Component{
    constructor(props){
        super(props);
        this.state={
            data:{},
            lblErrorMsg:""
        }
    }

    handleChange=(e)=>{
        const { name,value } = e.target;
        const { data } = this.state;
        data[name]=value;
        this.setState({
            data
        })
    };

    onLogin=()=>{
        const { data } = this.state;
        if ((Object.keys(data).length <= 1) || (data.Email === "") || (data.Password === ""))
            this.setState({
                lblErrorMsg: 'Both Fields are Required.'
            });
        else {
            this.props.loginAction(this.state.data).then((data) => {
                if(!data.results.ResponseCode && data.results.AppUser===null)
                {
                    this.setState({
                        lblErrorMsg: 'Invalid Credentials.'
                    });
                }
                else if (data.results.ResponseCode && data.results.BusinessUser && data.results.Token) {
                    audioFunc(true,false,'')
                    this.props.history.push(`/${routeName}/Dashboard/Overview`);
                }
                else {
                    this.props.next(this.props.data);
                }
            });
        }
    };

    render(){
        const { data,lblErrorMsg } = this.state;
        const { classes } = this.props;
        return(
            <div className='modal-container'>
                <Modal show={this.props.show} onHide={this.props.hide}>
                    <Modal.Header>
                        <Modal.Title>Log in inorder to import your profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="error">
                            {
                                ((lblErrorMsg!=='')?<span>{lblErrorMsg}</span>:<span/>)
                            }
                        </div>
                        <TextField
                            name="Email"
                            fullWidth={true}
                            placeholder={'Email, phone or username'}
                            inputProps={{
                                className: classes.textField
                            }}
                            margin={'normal'}
                            value={data.Email || ''}
                            onChange={this.handleChange}
                        />
                        <TextField
                            type={'password'}
                            name="Password"
                            fullWidth={true}
                            placeholder={'Password'}
                            inputProps={{
                                className: classes.textField
                            }}
                            onKeyDown={(e)=>{
                                if(e.keyCode===13)
                                    this.onLogin()
                            }}
                            margin={'normal'}
                            value={data.Password || ''}
                            onChange={this.handleChange}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Grid container alignItems={'right'} justify={'flex-end'}>
                            <Grid item sm={3} xs={6}>
                                <Button fullWidth={true} className={classes.button} variant={'contained'} color={'primary'} onClick={this.onLogin}>Log In</Button>
                            </Grid>
                            <Grid item sm={3} xs={6}>
                                <Button fullWidth={true} className={classes.cancelButton} color={'primary'} onClick={this.props.hide}>Cancel</Button>
                            </Grid>
                        </Grid>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        loginAction
    },dispatch)
};
export default connect(null,matchDispatchToProps)(withStyles(styles)(AppLogin));